import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronLeft } from "lucide-react";
import { Button } from "../components/ui/button";

export default function LegalPage() {
  const { t } = useTranslation("legal");

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 py-8">
        <Link to="/">
          <Button variant="ghost" className="mb-6" data-testid="back-to-home">
            <ChevronLeft className="h-4 w-4 mr-1" />
            {t("back")}
          </Button>
        </Link>

        <h1 className="text-3xl font-bold text-slate-900 mb-8">{t("legalTitle")}</h1>

        <div className="bg-white rounded-2xl shadow-sm p-6 sm:p-8 space-y-8 text-slate-700 leading-relaxed">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalEditorTitle")}</h2>
            <p>{t("legalEditorIntro")}</p>
            <ul className="mt-2 space-y-1">
              <li><strong>{t("legalEditorName")}</strong> {t("legalEditorNameValue")}</li>
              <li><strong>{t("legalEditorStatus")}</strong> {t("legalEditorStatusValue")}</li>
              <li><strong>{t("legalEditorAddress")}</strong> {t("legalEditorAddressValue")}</li>
              <li><strong>{t("legalEditorEmail")}</strong> {t("legalEditorEmailValue")}</li>
              <li><strong>{t("legalEditorPhone")}</strong> {t("legalEditorPhoneValue")}</li>
            </ul>
            <p className="mt-3"><strong>{t("legalPublisher")}</strong> {t("legalPublisherValue")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalHostingTitle")}</h2>
            <p>{t("legalHostingIntro")}</p>
            <ul className="mt-2 space-y-1">
              <li><strong>{t("legalHostingName")}</strong> {t("legalHostingNameValue")}</li>
              <li><strong>{t("legalHostingWebsite")}</strong> <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="text-omu-blue-500 underline">https://github.com</a></li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalPurposeTitle")}</h2>
            <p>{t("legalPurposeP1")}</p>
            <p className="mt-2">{t("legalPurposeP2")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalLiabilityTitle")}</h2>
            <p>{t("legalLiabilityP1")}</p>
            <p className="mt-2">{t("legalLiabilityP2")}</p>
            <p className="mt-2">{t("legalLiabilityP3")}</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>{t("legalLiabilityItem1")}</li>
              <li>{t("legalLiabilityItem2")}</li>
              <li>{t("legalLiabilityItem3")}</li>
            </ul>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalIpTitle")}</h2>
            <p>{t("legalIpP1")}</p>
            <p className="mt-2">{t("legalIpP2")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalDataTitle")}</h2>
            <p>{t("legalDataP1")}</p>
          </section>

          <hr className="border-slate-200" />

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-3">{t("legalLawTitle")}</h2>
            <p>{t("legalLawP1")}</p>
          </section>
        </div>

        <p className="text-center text-sm text-slate-400 mt-8">{t("footerCredit")}</p>
      </div>
    </div>
  );
}
